import type { Partner } from "@expert/shared-types";

export function getMappedIntent(intent: string, partner: Partner): string | undefined {
    if (partner === "mcafee") {
        switch (intent) {
            case "activate_software":
            case "download_software":
            case "installation_and_setup":
                return "Installation and setup";
            case "account_management":
            case "subscription_management":
                return "Account/Subscription management";
            case "viruses_malware_spam":
                return "Threat/Breach/Scam";
            case "uninstall_and_removal":
                return "Uninstall and removal";
            case "vpn":
                return "VPN help";
            case "features_and_benefits":
            case "usage_and_functionality":
            case "general_device_support":
                return "General device support";
            default:
                return undefined;
        }
    }

    if (intent === "out_of_scope") return undefined;
    return intent;
}
